module.exports = __webpack_public_path__ + "img/shiba-loading.3ba0188d.gif";